<add-manage-wrapper 
  *ngIf="displayType === displayTypes.narrowPod" 
  id="narrowExhibitorStandManager" 
  [titleIcon]="hideTitle ? null : 'STAND_NUMBER_18'" 
  [hideHRule]="true" 
  [wrapperTitle]="hideTitle ? '' : 'Exhibitors'" 
  [openLabel]="readOnly || (exhibitorStandIds.length === 0 && !programId) ? '' : '+ ADD AN EXHIBITOR STAND'" 
  (open)="addExhibitorStandThroughPopupDialog('narrowExhibitorStandManager')"
  >
    <div class="empty-text" *ngIf="!exhibitorStandIds.length">{{ emptyText }}</div>
    <ng-container *ngFor="let exhibitorStand of exhibitorStandIds | idsToItems:exhibitorStands; trackBy: trackById">
      <status-wrapper *ngIf="{ exhibitor: exhibitors[exhibitorStand.exhibitorId], program: programs[exhibitorStand.programId] } as vars"
        [ngClass]="{ clickable: !readOnly }"
        (click)="readOnly ? null : manageExhibitorStand(exhibitorStand)"
        [readOnly]="readOnly"
        [threeDotOptions]="programId ? programDotOptions : exhibitorDotOptions"
        [middleText]="!exhibitorId ? (vars.exhibitor?.name || 'No exhibitor') : (vars.program?.title || 'No program')"
        [status]="vars.exhibitor?.confirmed ? 'Confirmed' : 'Not Confirmed'" 
        [statusOptions]="['Confirmed', 'Not Confirmed']"
        [hideStatus]="!!exhibitorId"
        (changeStatus)="changeStatus(vars.exhibitor, $event)"
        (threeDotSelection)="dotMenuSelection($event, exhibitorStand)"
        >
        <div class="titles">
          <div class="boldContent" [ngClass]="{unnamed: !exhibitorStand.name }">{{ exhibitorStand.name || 'Unnamed exhibitor stand' }}</div>
          <div *ngIf="!!exhibitorStand.standTypeId">{{ standTypes[exhibitorStand.standTypeId].name }}</div>
        </div>
      </status-wrapper>
    </ng-container>
</add-manage-wrapper>
<add-manage-wrapper 
  *ngIf="displayType === displayTypes.widePod" 
  cdkDropList  
  (cdkDropListDropped)="dropExhibitorIds($event)"
  class="performer-list wide"
  id="wideExhibitorStandManager"
  [titleIcon]="hideTitle ? null : 'STAND_NUMBER_18'" 
  [hideHRule]="true"  
  [wrapperTitle]="hideTitle ? '' : 'Exhibitor Stands'" 
  [openLabel]="readOnly || (!hasExhibitorStandsToChooseFrom && !programId) ? '' : '+ ADD AN EXHIBITOR STAND'" 
  (open)="addExhibitorStandThroughPopupDialog($event)"
>
<ng-container *ngIf="!exhibitorStandIds.length">
  <div class="empty-text" *ngIf="hasExhibitorStandsToChooseFrom">No exhibitor stands attached</div>
  <div class="empty-text" *ngIf="!hasExhibitorStandsToChooseFrom">{{ emptyText }}</div>
</ng-container>
<div class="drag-wrapper" cdkDrag *ngFor="let exhibitorStand of exhibitorStandIds | idsToItems:exhibitorStands; trackBy: trackById">
  <icon class="handle" *ngIf="!readOnly" matIcon="drag_indicator" cdkDragHandle></icon>
  <status-wrapper *ngIf="{ exhibitor: exhibitors[exhibitorStand.exhibitorId], program: programs[exhibitorStand.programId] } as vars"
    [ngClass]="{ clickable: !readOnly }"
    (click)="readOnly ? null : manageExhibitorStand(exhibitorStand)"
    [wideFormat]="true"
    [readOnly]="readOnly"
    [threeDotOptions]="programId ? programDotOptions : exhibitorDotOptions"
    [middleText]="!exhibitorId ? (vars.exhibitor?.name || 'No exhibitor') : (vars.program?.title || 'No program')"
    [status]="vars.exhibitor?.confirmed ? 'Confirmed' : 'Not Confirmed'" 
    [statusOptions]="['Confirmed', 'Not Confirmed']"
    [hideStatus]="!!exhibitorId"
    (changeStatus)="changeStatus(vars.exhibitor, $event)"
    
    (threeDotSelection)="dotMenuSelection($event, exhibitorStand)"
    >
    <div class="titles wideContent">
      <div class="boldContent" [ngClass]="{unnamed: !exhibitorStand.name }">{{ exhibitorStand.name || 'Unnamed exhibitor stand' }}</div>
      <div class="stand-name" *ngIf="!!exhibitorStand.standTypeId">{{ standTypes[exhibitorStand.standTypeId].name }}</div>
    </div>
  </status-wrapper>
</div>
</add-manage-wrapper>
<div class="read-only-holder" *ngIf="displayType === displayTypes.readOnly && !!exhibitorStandIds.length">
  <h5 *ngIf="!hideTitle">EXHIBITORS</h5>
  <sponsor-card class="read-only-card" *ngFor="let exhibitor of exhibitorStandIds | idsToItems:exhibitors; trackBy: trackById" [sponsor]="exhibitor" [bold]="true"></sponsor-card>
</div>